/**
 * Navigation store.
 *
 * React Router owns the URL; this store mirrors the *semantic* navigation
 * state the UI cares about — the active destination and a short trail of
 * recently visited routes — so components like the sidebar and status bar can
 * react without each subscribing to the router directly.
 */
import { create } from "zustand";
import type { RouteId } from "@/types";

const MAX_HISTORY = 10;

interface NavigationState {
  current: RouteId;
  history: RouteId[];
  /** Record a visit. Called by the layout on every location change. */
  visit: (route: RouteId) => void;
}

export const useNavigationStore = create<NavigationState>()((set) => ({
  current: "chat",
  history: ["chat"],
  visit: (route) =>
    set((s) => {
      if (s.current === route) return s;
      const history = [route, ...s.history.filter((r) => r !== route)].slice(
        0,
        MAX_HISTORY,
      );
      return { current: route, history };
    }),
}));
